import React from "react"

export default function Error() {
  return (
    <symbol id="svg-error" viewBox="0 0 36 36">
      <path
        fill="currentColor"
        d="M30 18c0-6.7-5.3-12-12-12S6 11.3 6 18s5.3 12 12 12 12-5.3 12-12zM8.2 18c0-5.5 4.4-9.8 9.8-9.8s9.8 4.4 9.8 9.8-4.4 9.8-9.8 9.8-9.8-4.3-9.8-9.8zm12.3 4L18 19.5 15.5 22c-.4.4-1.1.4-1.5 0-.2-.2-.3-.4-.3-.8 0-.3.1-.5.3-.8l2.5-2.5-2.5-2.4c-.2-.2-.3-.4-.3-.8 0-.3.1-.5.3-.8.4-.4 1.1-.4 1.5 0l2.5 2.5 2.5-2.5c.4-.4 1.1-.4 1.5 0s.4 1.1 0 1.5L19.5 18l2.5 2.5c.4.4.4 1.1 0 1.5s-1.1.5-1.5 0z"
      />
    </symbol>
  )
}
